import { Leaf, TrendingUp, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import PublicShell from '@/components/layouts/PublicShell';

const NachhaltigeGeldanlagenPage = () => {
  return (
    <PublicShell>
      {/* Hero Section - Exact Height */}
      <div className="relative" style={{height: '70vh'}}>
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{backgroundImage: 'url(/images/sv-handshake.jpg)'}}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/75 via-slate-800/60 to-transparent"></div>

        <div className="relative z-10 h-full flex items-center px-16">
          <div className="max-w-3xl">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-light text-white mb-8 leading-tight font-serif">
              Nachhaltige Geldanlagen
            </h1>

            <p className="text-xl md:text-2xl text-slate-200 leading-relaxed mb-10 max-w-3xl">
              Investieren mit Verantwortung - für eine bessere Zukunft und attraktive Renditen
            </p>

          </div>
        </div>
      </div>

      {/* Green Section */}
      <div className="bg-primary-800">
        <div className="grid grid-cols-1 lg:grid-cols-5">
          {/* Left Side - Text (3 columns) */}
          <div className="lg:col-span-3 p-12 lg:p-20 flex items-center">
            <div className="max-w-2xl">
              <div className="w-16 h-16 mb-8">
                <Leaf className="w-16 h-16 text-white" />
              </div>

              <h2 className="text-4xl md:text-5xl font-light text-white mb-8 leading-tight font-serif">
                ESG-Kriterien im <em className="italic">Fokus</em>
              </h2>

              <p className="text-xl text-primary-100 leading-relaxed">
                Environmental, Social und Governance - diese drei Säulen bilden das Fundament nachhaltiger Geldanlagen.
                Investitionen mit positiver Wirkung auf Umwelt und Gesellschaft.
              </p>
              </div>
            </div>

          {/* Right Side - Image (2 columns) */}
          <div className="lg:col-span-2 relative min-h-96">
            <div
              className="absolute inset-0 bg-cover bg-center"
              style={{backgroundImage: 'url(/images/sv-group-meeting.jpg)'}}
            ></div>
                      </div>
                    </div>
                  </div>

      {/* Three White Cards Section - ESG Criteria */}
      <div className="relative -mt-16 z-20">
        <div className="max-w-[1720px] mx-auto px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24">
          {/* Single Large White Box */}
          <div className="bg-white rounded-none shadow-[0_8px_40px_rgba(16,24,40,0.08)] w-full mb-12">
            <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-gray-200">
              {/* Card 1 - Environmental */}
              <div className="px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24 py-12 text-left">
                <h3 className="text-xl font-bold text-slate-800 mb-6 leading-tight">Environmental (Umwelt)</h3>
                <p className="text-[16px] text-slate-600 leading-relaxed">
                  Investitionen in Unternehmen, die Umweltschutz und Klimaschutz aktiv fördern und
                  nachhaltige Geschäftspraktiken verfolgen. Fokus auf erneuerbare Energien und Ressourcenschonung.
                </p>
              </div>

              {/* Card 2 - Social */}
              <div className="px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24 py-12 text-left">
                <h3 className="text-xl font-bold text-slate-800 mb-6 leading-tight">Social (Soziales)</h3>
                <p className="text-[16px] text-slate-600 leading-relaxed">
                  Fokus auf Unternehmen mit fairen Arbeitsbedingungen, sozialer Verantwortung
                  und positiven Auswirkungen auf die Gesellschaft. Förderung von Diversity und Inklusion.
                </p>
            </div>

              {/* Card 3 - Governance */}
              <div className="px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24 py-12 text-left">
                <h3 className="text-xl font-bold text-slate-800 mb-6 leading-tight">Governance (Führung)</h3>
                <p className="text-[16px] text-slate-600 leading-relaxed">
                  Investitionen in Unternehmen mit transparenter, ethischer Unternehmensführung
                  und verantwortungsvollem Management. Hohe Standards bei Compliance und Transparenz.
                </p>
              </div>
            </div>
          </div>
        </div>
          </div>

      {/* Purple Section - Doppelte Dividende */}
      <div className="bg-primary-900 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-5">
          {/* Left Side - Text (3 columns) */}
          <div className="lg:col-span-3 p-12 lg:p-20 flex items-center">
            <div className="max-w-2xl">
              <div className="w-16 h-16 mb-8">
                <TrendingUp className="w-16 h-16 text-white" />
              </div>

              <h2 className="text-4xl md:text-5xl font-light text-gold-400 mb-8 leading-tight font-serif">
                Doppelte <em className="italic">Dividende</em>
              </h2>

              <p className="text-xl text-primary-100 leading-relaxed">
                Nachhaltige Geldanlagen bieten eine doppelte Dividende: attraktive finanzielle Erträge
                und positive Auswirkungen auf Umwelt und Gesellschaft.
              </p>
            </div>
            </div>

          {/* Right Side - Image (2 columns) */}
          <div className="lg:col-span-2 relative min-h-96">
            <div
              className="absolute inset-0 bg-cover bg-center"
              style={{backgroundImage: 'url(/images/sv-skyline-evening.jpg)'}}
            ></div>
            </div>
          </div>
        </div>

      {/* Three White Cards Section - Approaches */}
      <div className="relative -mt-16 z-20">
        <div className="max-w-[1720px] mx-auto px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24">
          {/* Single Large White Box */}
          <div className="bg-white rounded-none shadow-[0_8px_40px_rgba(16,24,40,0.08)] w-full mb-12">
            <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-gray-200">
              {/* Card 1 - ESG-Screening */}
              <div className="px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24 py-12 text-left">
                <h3 className="text-xl font-bold text-slate-800 mb-6 leading-tight">ESG-Screening</h3>
                <p className="text-[16px] text-slate-600 leading-relaxed">
                  Systematische Analyse und Bewertung von Unternehmen anhand von ESG-Kriterien
                  für eine fundierte Investitionsentscheidung. Ausschluss von Unternehmen,
                  die gegen unsere Nachhaltigkeitsstandards verstoßen.
                </p>
              </div>

              {/* Card 2 - ESG-Integration */}
              <div className="px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24 py-12 text-left">
                <h3 className="text-xl font-bold text-slate-800 mb-6 leading-tight">ESG-Integration</h3>
                <p className="text-[16px] text-slate-600 leading-relaxed">
                  Vollständige Integration von ESG-Faktoren in den Anlageprozess als zentraler
                  Bestandteil der Risiko- und Renditeanalyse. Berücksichtigung von Nachhaltigkeitsrisiken
                  und -chancen bei allen Investitionsentscheidungen.
                </p>
        </div>

              {/* Card 3 - Active Ownership */}
              <div className="px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24 py-12 text-left">
                <h3 className="text-xl font-bold text-slate-800 mb-6 leading-tight">Active Ownership</h3>
                <p className="text-[16px] text-slate-600 leading-relaxed">
                  Aktive Ausübung von Stimmrechten und direkter Dialog mit Unternehmen
                  zur Förderung nachhaltiger Geschäftspraktiken. Kontinuierliches Engagement
                  für positive Veränderungen in der Unternehmensführung.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

      {/* CTA Section - Green */}
      <div className="bg-primary-800 py-16">
        <div className="max-w-[1720px] mx-auto px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24 text-center">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              Investieren Sie in die Zukunft
        </h2>
            <p className="text-xl text-primary-100 mb-8 leading-relaxed">
              Verbinden Sie Ihre finanziellen Ziele mit Ihren Werten.
              Entdecken Sie unsere nachhaltigen Anlagelösungen.
            </p>
            <Link to="/contact">
              <Button className="bg-white text-primary-700 hover:bg-gray-100 px-8 py-4 text-lg font-medium rounded-none shadow-lg border border-gray-200">
                <span className="text-primary-700 font-bold">Nachhaltige Beratung vereinbaren</span>
                <ArrowRight className="ml-2 w-5 h-5 text-primary-700" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </PublicShell>
  );
};

export default NachhaltigeGeldanlagenPage;
